import { useEffect, useRef } from "react";
import { PartOrder } from "../generated/nest-graphql";
import { isWithdrawnJob } from "../components/Parts/partsStatus.utils";

// "View Parts" on a withdrawn job would otherwise land on an empty All tab. Decided once, on
// network data: a cache-and-network query first replays the cache, which may predate the withdrawal.
export const useWithdrawnJobFilter = ({
  orders,
  loading,
  jobId,
  onWithdrawn,
}: {
  orders: PartOrder[];
  loading: boolean;
  jobId: string | null;
  onWithdrawn: () => void;
}): void => {
  const decidedFor = useRef<string | null>(null);
  useEffect(() => {
    if (loading || !jobId || decidedFor.current === jobId) return;
    const withdrawn = isWithdrawnJob(orders, jobId);
    if (withdrawn === null) return;
    decidedFor.current = jobId;
    if (withdrawn) onWithdrawn();
  }, [orders, loading, jobId, onWithdrawn]);
};
